import generateStore from './generateStore.js'

export default (app) => {
  const store = generateStore('outboundEmails', app)
  return store
}
